import * as actionTypes from './capacityActionTypes';
import { CapacityStateModel } from './capacityStateModel';
import { mergeUpdateObj } from 'shared/shared.utilities';



export const initialCostsState: CapacityStateModel = {};


const capacityReducer = (state: CapacityStateModel = initialCostsState, action) => {
    switch (action.type) {
        case actionTypes.GET_CAPACITY_SUCCESS:
            return mergeUpdateObj(state, { capacity: action.payload });
        case actionTypes.GET_CAPACITY_FAILURE:
            return mergeUpdateObj(state, { capacityErrorMessage: action.payload });
        case actionTypes.FETCHING_CAPACITY:
            return mergeUpdateObj(state, { fetchingCapacity: action.payload });
    }

    return state;
}



export default capacityReducer;